import React, { useEffect, useReducer, useRef } from 'react'
import { userReducer } from '../../reducer/reducers/userReducer';
import Cookies from 'universal-cookie';
import { registerDetails } from '../../reducer/initialStates/initialStates';
import { userLocationReducer } from '../../reducer/reducers/userLocationReducer';
import { utilityReducer } from '../../reducer/reducers/utiltiyReducer';
import { GlobalContext } from '../../reducer/context';
import { getLatLng } from '../dashboard/common/DashboardUtils';
import { SET_LOCATION, SET_LOCATION_ERROR } from '../../reducer/actions/userLocationActions';
import { LS_ORDER_TYPE_KEY, SET_LOADING_FALSE } from '../../reducer/actions/utilityActions';
import { DINE_IN } from '../../translations/en/en';
import { safeParse } from '../../utils/GetSetStorage';

const cookies = new Cookies();
const initialAddress = {
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    addressType: "",
    latitude: 0,
    longitude: 0,
    recordId: 0,
    consent: false,
    isError: false,
    errorMessage: ''
}

export const AppContextWrapper = ({ children }) => {
    const authToken = cookies.get("authToken");
    const locationFetchedRef = useRef(false);

    const [authState, dispatchAuth] = useReducer(userReducer, {
        isAuthenticated: authToken !== undefined,
        authToken: authToken ?? null,
        user: null,
        showLoginModal: false,
        showEditProfileModal: false,
        showBookTableModal: false,
        showLoginConfirmationModal: false,
        registerDetails: { ...registerDetails },
    });
    const [userLocation, dispatchLocation] = useReducer(userLocationReducer, safeParse("selectedUserAddress", { ...initialAddress }));
    const [utilityStates, dispatchUtility] = useReducer(utilityReducer, {
        userCart: safeParse("userCart", null),
        orderType: safeParse(LS_ORDER_TYPE_KEY, DINE_IN),
        restaurantList: null,
        restaurantId: safeParse("restaurantId", null),
        restaurantName: null,
        restaurantRecordId: null,
        selectedHeaderRestaurant: safeParse("selectedRestaurantMetaData", { value: "", label: "", recordId: "" }),
        loading: false,
        isQrScanned: false,
        hideDashboardBanner: false,
    });

    useEffect(() => {
        if (userLocation.latitude || userLocation.longitude) {
            localStorage.setItem("selectedUserAddress", JSON.stringify(userLocation));
        }
    }, [userLocation]);
    
    useEffect(() => {
        if (utilityStates.userCart && utilityStates.userCart.length > 0) {
            localStorage.setItem("userCart", JSON.stringify(utilityStates.userCart));
            const { restaurantId, restaurantName, orderType } = utilityStates.userCart[0];
            localStorage.setItem("userCartMetaData", JSON.stringify({ restaurantId, restaurantName, orderType }));
        } else {
            localStorage.removeItem("userCart");
            localStorage.removeItem("userCartMetaData");
        }
    }, [utilityStates.userCart]);

    useEffect(() => {
        localStorage.setItem(LS_ORDER_TYPE_KEY, JSON.stringify(utilityStates.orderType));
    }, [utilityStates.orderType]);

    useEffect(() => {
        if (utilityStates.restaurantId) {
            localStorage.setItem("restaurantId", JSON.stringify(utilityStates.restaurantId));
            localStorage.setItem("selectedRestaurantMetaData", JSON.stringify(utilityStates.selectedHeaderRestaurant))
        }
    }, [utilityStates.restaurantId]);

    useEffect(() => {
        if (utilityStates.orderType !== DINE_IN && !locationFetchedRef.current) {
            locationFetchedRef.current = true;
            getLatLng().then(address => {
                dispatchLocation({ type: SET_LOCATION, payload: address });
            }).catch((error) => {
                dispatchUtility({ type: SET_LOADING_FALSE });
                dispatchLocation({ type: SET_LOCATION_ERROR, payload: {isError: true, errorMessage: error.message}})
            })
        }
        if (utilityStates.orderType === DINE_IN) {
            locationFetchedRef.current = false;
        }
    }, [utilityStates.orderType]);

    return (
        <GlobalContext.Provider
            value={{
                authState,
                userLocation,
                utilityStates,
                dispatchAuth,
                dispatchLocation,
                dispatchUtility,
            }}
        >
            {children}
        </GlobalContext.Provider>
    )
}